import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const blueCherrySettings = defineIntegrationSettings({
  fields: {
    companyCode: z.string().trim().min(1, "Company code is required"),
    environmentCode: z.string().trim().min(1, "Environment code is required"),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
